export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-semibold mb-4">
                随时随地观影
              </span>
              <h2 className="text-2xl md:text-3xl font-extrabold text-background-50 font-heading mb-3">
                蓝莓影院 · 多端畅享
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
                全面支持电脑、平板与手机访问，响应式设计自动适配屏幕。
                横屏观影、手势控制、云端同步观影进度，让你随时随地享受影院级体验。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50/15 text-background-50 text-sm font-medium">
                  <i className="ri-computer-line"></i>
                  <span>电脑端</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50/15 text-background-50 text-sm font-medium">
                  <i className="ri-tablet-line"></i>
                  <span>平板端</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-lg bg-background-50/15 text-background-50 text-sm font-medium">
                  <i className="ri-smartphone-line"></i>
                  <span>手机端</span>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20cinematic%20movie%20streaming%20interface%20with%20warm%20golden%20and%20amber%20color%20scheme%2C%20floating%20beside%20tablet%20and%20laptop%20in%20soft%20background%20blur%2C%20clean%20modern%20device%20mockup%2C%20cinematic%20app%20design%2C%20rich%20warm%20tones&width=300&height=400&seq=app-device&orientation=portrait"
                alt="蓝莓影院多端观影"
                className="w-48 md:w-56 h-auto rounded-xl"
                loading="lazy"
                width="300"
                height="400"
                title="蓝莓影院多端观影"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}